// extracted by mini-css-extract-plugin
module.exports = {"errorImg":"Error_errorImg__dV0H9","error":"Error_error__oVrsJ","button":"Error_button__i_DCL"};